import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import getStatsDataByEventIdThunk from '../store/statsData/actions/getStatsDataByEventId';
import {StatData} from '../utils/types';
import {AppState} from '../store/types';

/**
 * Return type of the useStatsData hook
 */
type UseStatsDataResult = [
  {loading: boolean; data?: StatData[]; error?: string | boolean},
  {getStatsDataByEventId: typeof getStatsDataByEventIdThunk}
];

/**
 * Selects the 'statsData' state and sum it up into a referring object
 */
const statsDataSelector = (state: AppState) => ({
  loading: state.statsData.isFetching,
  data: state.statsData.data,
  error: state.statsData.didInvalidate ? state.statsData.error : false,
});

/**
 * Wraps up the business logic of selecting the 'statsData' state.
 */
const useStatsData = (): UseStatsDataResult => {
  const dispatch = useDispatch();
  const state = useSelector(statsDataSelector);

  const getStatsDataByEventId = useCallback(
    (id: string) => dispatch(getStatsDataByEventIdThunk(id)),
    [dispatch],
  );

  return [state, {getStatsDataByEventId}];
};

export default useStatsData;
